import React from "react"
import { Link, useNavigate } from "react-router-dom"
import styles from './AppLink.module.css'

export const AppLink = ({ to, action, ...rest }) => {
    const navigate = useNavigate()
    const handleClick = (e) => {
        e.preventDefault()
        if (to) {
            navigate(to)
        } else {
            action()
        }
    }

    return <Link
        className={styles.link}
        to={to ? to : ''}
        onClick={(e) => handleClick(e)}
    >{rest.children}</Link>
}